const playBtnClicked = (container) => {
  const playButton = container.querySelector('[data-video]');
  playButton.removeEventListener('click', playBtnClicked);

  // Get stream url
  const streamSource = playButton.dataset.video;
  const videoIdMatches = streamSource.match(/((embed\/)|(\?{0,1}v=))[a-zA-Z0-9_-]{11}/);
  let videoId = null;

  if (videoIdMatches.length > 0) {
    videoId = videoIdMatches[0].split(/[=\/]/);

    if (videoId.length > 0) {
      videoId = videoId[1];
    }
  }

  if (streamSource && videoId) {
    // Show loader
    playButton.classList.add('load');

    // Create iframe
    const video = document.createElement('div');
    // Add attributes
    //   video.src = streamSource;
    video.classList.add('item__video');
    video.setAttribute('id', 'video__video');

    // Add iframe to DOM
    const containerVideo = container.querySelector(`[data-item="video-container"]`);
    containerVideo.appendChild(video);

    // This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    let player;

    const onYouTubeIframeAPIReady = () => {
      player = new YT.Player(video, {
        height: '1080',
        width: '1920',
        videoId: videoId,
        playerVars: {
          rel: 0,
          showinfo: 0,
          ecver: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          cc_load_policy: 0,
          showsearch: 0,
          controls: 2,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });
    };

    // This code loads the IFrame Player API code asynchronously.
    const script = document.createElement('script');

    script.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    script.addEventListener('load', () => {
      setTimeout(() => {
        onYouTubeIframeAPIReady();

        playButton.classList.remove('load');
      }, 500);
    });

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.playVideo();
      playButton.style.zIndex = '-1';

      const placeholder = container.querySelector('[data-item="placeholder"]');

      if (placeholder) {
        placeholder.style.zIndex = '-1';
      }

      const videoPlayer = container.querySelector('iframe');

      if (videoPlayer) {
        videoPlayer.style.zIndex = '200';
      }
    }

    // 5. The API calls this function when the player's state changes.
    //    The function indicates that when playing a video (state=1),
    //    the player should play for six seconds and then stop.
    const onPlayerStateChange = (event) => {
      if (event.data == YT.PlayerState.ENDED) {
        playButton.style.zIndex = '20';
        playButton.addEventListener('click', playBtnClicked);
        playButton.classList.remove('load');
        const placeholder = container.querySelector('[data-item="placeholder"]');

        if (placeholder) {
          placeholder.style.zIndex = '0';
        }

        const videoPlayer = container.querySelector('iframe');

        if (videoPlayer) {
          videoPlayer.remove();
        }
      }
    };
  }
};

document.querySelectorAll('[data-video-item="true"]').forEach((elem) => {
  const playButton = elem.querySelector('[data-video]');
  const container = elem.querySelector('[data-item="video"]');

  if (playButton && container) {
    // Add on click to play button
    playButton.addEventListener('click', () => playBtnClicked(elem));
  }
});
